import React, { useContext } from "react";
import "../index.css";
import { MDBCol, MDBRow, MDBBtn } from "mdbreact";
import { Link } from "react-router-dom";
import { Authcontext } from "../context/Authcontext";
import {useHistory} from "react-router-dom";

const Frontpage = () => {
  const { User, signin } = useContext(Authcontext);
  let history = useHistory();

  const renderToBookshelf = ()=>{
    history.push("/show");
  }

  return (
    <div
      className="bg"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",

      }}
    >
      <Link to={"/show"} className="link">
        {" "}
        <h1 className="title" style={{}}>
      <b>Manage my Bookshelf...</b>  
        </h1>
      </Link>
      <div>
        {User === null ? (
          <MDBBtn
            size="bg"
            rounded
            color="#c51162"
            light
            
            style={{
              color : "white",
              backgroundColor : "#c51162",
              border :  "2px white"
            }}

            onClick={signin}
          >
            Sign in
          </MDBBtn>
        ) : (
          <MDBBtn
            size="bg"
            rounded
            color="#c51162"
            light
            style={{
              color : "white",
              backgroundColor : "#c51162"
            }}
            onClick={renderToBookshelf}
          >
            Go to My Bookshelf
          </MDBBtn>
        )}
      </div>
    </div>
  );
};
export default Frontpage;
